export const menuItems = [
    {
        id: 1,
        label: "menuitems.navigation.text",
        isTitle: true
    },
    {
        id: 2,
        label: 'menuitems.users.text',
        icon: 'ri-table-line',
        isMenuCollapsed: false,
        subItems: [
            {
                id: 3,
                label: 'menuitems.users.list.admin',
                link: '/users/admin'
            },
            {
                id: 4,
                label: 'menuitems.users.list.mobile',
                link: '/users/mobile'
            },
        ]
    },
    {
        id: 5,
        label: 'menuitems.exports.text',
        icon: 'ri-file-download-line',
        isMenuCollapsed: false,
        subItems: [
            {
                id: 6,
                label: 'menuitems.exports.list.searchlog',
                link: '/report/searchlog'
            },
            {
                id: 7,
                label: 'menuitems.exports.list.lastlogin',
                link: '/report/lastlogin'
            },
        ]
    },
];

export const menuAdmin = [
    {
        id: 1,
        label: "menuitems.navigation.text",
        isTitle: true
    },
    {
        id: 2,
        label: 'menuitems.users.text',
        icon: 'ri-table-line',
        isMenuCollapsed: false,
        subItems: [
            {
                id: 4,
                label: 'menuitems.users.list.mobile',
                link: '/users/mobile'
            },
        ]
    },
];

